// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gvr_","footer":"styles_footer__15sB7"};